<script setup>
import { ref } from 'vue';

import AppMenuItem from './AppMenuItem.vue';

const model = ref([
    {
        label: 'Home',
        items: [
            { label: 'Getting started', icon: 'pi pi-fw pi-compass', to: '/onboarding' },
            { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/dashboard' },
            { label: 'Bank Accounts', icon: 'pi pi-fw pi-building-columns', to: '/accounts', tourId: 'nav-accounts' },
        ]
    },
    {
        label: 'Track Spending',
        items: [
            { label: 'Budget', icon: 'pi pi-fw pi-book', to: '/budget', tourId: 'nav-budget' },
            { label: 'Transactions', icon: 'pi pi-fw pi-receipt', to: '/transactions', tourId: 'nav-transactions' },
            { label: 'Reports', icon: 'pi pi-fw pi-chart-bar', to: '/reports', tourId: 'nav-reports' },
        ]
    },
    {
        label: 'Collect Payments',
        items: [
            { label: 'Members', icon: 'pi pi-fw pi-users', to: '/members', tourId: 'nav-members' },
            { label: 'Dues', icon: 'pi pi-fw pi-calendar', to: '/dues', tourId: 'nav-dues' },
            { label: 'Invoices', icon: 'pi pi-fw pi-envelope', to: '/invoices', tourId: 'nav-invoices' },
        ]
    }
]);
</script>

<template>
    <ul class="layout-menu">
        <template v-for="(item, i) in model" :key="item">
            <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
            <li v-if="item.separator" class="menu-separator"></li>
        </template>
    </ul>
</template>

<style lang="scss" scoped></style>
